import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ContentPage } from 'src/app/enums/content-page.enum';

@Component({
  selector: 'app-conferences',
  templateUrl: './conferences.component.html',
  styleUrls: ['./conferences.component.scss']
})
export class ConferencesComponent implements OnInit {
  profesional = ContentPage.esES.health.profesional[0];
  videos = ContentPage.esES.health.profesional[0].videos;
  videoCurrent: any;

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {

    let language = localStorage.getItem('language');
    if (language == 'esEN') {
      this.profesional = language == 'esEN' ? ContentPage.esEN.health.profesional[0] : ContentPage.esES.health.profesional[0];
      this.videos = language == 'esEN' ? ContentPage.esEN.health.profesional[0].videos : ContentPage.esES.health.profesional[0].videos;
    }

    // @ts-ignore
    this.videos = this.videos.map(video => ({
      ...video,
      safeUrl: this.getDomSanitizerSecondary(video.url)
    }));

    // @ts-ignore
    if (this.videos?.length > 0) {
      // @ts-ignore
      this.getDomSanitizer(this.videos[0].url);
    }
  }

  getDomSanitizer(url: string) {
    this.videoCurrent = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getDomSanitizerSecondary(url: string): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`${url}&controls=0&dnt=1`);
  }

  changeVideo(video: any) {
    // @ts-ignore
    this.videos.forEach(item => {
      item.selected = false;
    });
    video.selected = true;
    this.getDomSanitizer(video.url);
  }

  trackByVideo(index: number, video: any): number {
    return video.id ? video.id : index;
  }

}
